// Icons for the newForms
import { ReactComponent as SectionIcon } from "assets/svg/section.svg";
import { ReactComponent as InstructionIcon } from "assets/svg/information.svg";
import { ReactComponent as YesNoIcon } from "assets/svg/yesno.svg";
import { ReactComponent as TextIcon } from "assets/svg/text.svg";
import { ReactComponent as MultipleChoiceIcon } from "assets/svg/multiplechoice.svg";
import { ReactComponent as NumberIcon } from "assets/svg/number.svg";
import { ReactComponent as CheckboxIcon } from "assets/svg/checkbox.svg";
import { ReactComponent as DateTimeIcon } from "assets/svg/datetime.svg";
import { ReactComponent as RatingIcon } from "assets/svg/rating.svg";
import { ReactComponent as EmailIcon } from "assets/svg/email.svg";
import { ReactComponent as StopwatchIcon } from "assets/svg/stopwatch.svg";
import { ReactComponent as Photo } from "assets/svg/photo.svg";
import { ReactComponent as Barcode } from "assets/svg/barcode.svg";
import { ReactComponent as Video } from "assets/svg/video.svg";
import { ReactComponent as Signature } from "assets/svg/signature.svg";
import { ReactComponent as Document } from "assets/svg/document.svg";
import { ReactComponent as Formula } from "assets/svg/formula.svg";
import { ReactComponent as Location } from "assets/svg/location.svg";

//Component for scoring
import YesNoScoreComponent from "components/pages/forms/scoreFields/yesNo/YesNoScoreComponent";
import StopWatchScoreComponent from "components/pages/forms/scoreFields/stopwatch/StopWatchScoreComponent";
import RatingScoreComponent from "components/pages/forms/scoreFields/rating/RatingScoreComponent";
import CheckBoxScoreComponent from "components/pages/forms/scoreFields/checkbox/CheckBoxScoreComponent";
import MultipleScoreChoice from "components/pages/forms/scoreFields/multiplechoice/MultipleScoreComponent";
import NumberScoreComponent from "components/pages/forms/scoreFields/number/NumberScoreComponent";

//Component MetaData

import Field from "components/pages/forms/metaFields/field/Field";


// Component for the newForms
import SectionField from "components/pages/forms/fields/section/SectionField";
import InstructionsField from "components/pages/forms/fields/instructions/InstructionsField";
import NewYesNoComponent from "components/pages/forms/fields/yesNo/NewYesNoComponent";
import TextComponent from "components/pages/forms/fields/text/TextComponent";
import MultipleChoice from "components/pages/forms/fields/multiplechoice/MultipleChoice";
import NumberComponent from "components/pages/forms/fields/number/NumberComponent";
import CheckBoxComponent from "components/pages/forms/fields/checkbox/CheckBoxComponent";
import DateTimeComponent from "components/pages/forms/fields/timedate/DateTimeComponent";
import RatingComponent from "components/pages/forms/fields/rating/RatingComponent";
import EmailComponent from "components/pages/forms/fields/email/EmailComponent";
import StopWatch from "components/pages/forms/fields/stopwatch/StopWatch";
import PhotoComponent from "components/pages/forms/fields/photo/PhotoComponent";
import SignatureComponent from "components/pages/forms/fields/signature/SignatureComponent";
import BarcodeComponent from "components/pages/forms/fields/barcode/BarcodeComponent";
import VideoComponent from "components/pages/forms/fields/video/VideoComponent";
import DocumentComponent from "components/pages/forms/fields/document/DocumentComponent";
import FormulaComponent from "components/pages/forms/fields/formula/FormulaComponent";
import LocationComponent from "components/pages/forms/fields/location/LocationComponent";

//components for previewFormFields
import PreviewInstructions from "components/pages/forms/previewFormFields/previewinstruction/PreviewInstructions";
import PreviewSection from "components/pages/forms/previewFormFields/previewsection/PreviewSection";
import PreviewYesNo from "components/pages/forms/previewFormFields/previewYesNo/PreviewYesNo";
import PreviewText from "components/pages/forms/previewFormFields/previewText/PreviewText";
import PreviewMultipleChoice from "components/pages/forms/previewFormFields/previewMultipleChoice/PreviewMultipleChoice";
import PreviewNumber from "components/pages/forms/previewFormFields/previewNumber/PreviewNumber";
import PreviewCheckbox from "components/pages/forms/previewFormFields/previewCheckbox/PreviewCheckbox";
import PreviewDateTime from "components/pages/forms/previewFormFields/previewDateTime/PreviewDateTime";
import PreviewRating from "components/pages/forms/previewFormFields/previewRating/PreviewRating";
import PreviewEmail from "components/pages/forms/previewFormFields/previewEmail/PreviewEmail";
import PreviewStopwatch from "components/pages/forms/previewFormFields/previewStopwatch/PreviewStopwatch";
import PreviewPhoto from "components/pages/forms/previewFormFields/previewPhoto/PreviewPhoto";
import PreviewSignature from "components/pages/forms/previewFormFields/previewSignature/PreviewSignature";
import PreviewBarcode from "components/pages/forms/previewFormFields/previewBarcode/PreviewBarcode";
import PreviewVideo from "components/pages/forms/previewFormFields/previewVideo/PreviewVideo";
import PreviewDocument from "components/pages/forms/previewFormFields/previewDocument/PreviewDocument";
import PreviewFormula from "components/pages/forms/previewFormFields/previewFormula/PreviewFormula";
import PreviewLocation from "components/pages/forms/previewFormFields/previewLocation/PreviewLocation";
import { privatePost } from "services/privateRequest";
import { UPLOAD } from "services/apiEndpoints";
import dayjs from "dayjs";
import SubmittedBy from "components/pages/forms/metaFields/submittedby/SubmittedBy";
import DateSubmitted from "components/pages/forms/metaFields/datesubmitted/DateSubmitted";
import Project from "components/pages/forms/metaFields/project/Project";
import DistanceLocation from "components/pages/forms/metaFields/distancelocation/DistanceLocation";
import TimeToComplete from "components/pages/forms/metaFields/timetocomplete/TimeToComplete";
import YesNo from "components/pages/forms/components/triggerfields/yesno/YesNo";
import MultipleChoiceTrigger from "components/pages/forms/components/triggerfields/multiplechoice/MultipleChoice";
import Rating from "components/pages/forms/components/triggerfields/rating/Rating";
import Text from "components/pages/forms/components/triggerfields/text/Text";
import Number from "components/pages/forms/components/triggerfields/number/Number";
import StopWatchTrigger from "components/pages/forms/components/triggerfields/stopwatch/StopWatch";
import CheckboxTrigger from "components/pages/forms/components/triggerfields/checkbox/Checkbox";
import EmailTrigger from "components/pages/forms/components/triggerfields/email/Email";
import DateTimeTrigger from "components/pages/forms/components/triggerfields/datetimetrigger/DateTimeTrigger";
import SignatureTrigger from "components/pages/forms/components/triggerfields/signature/Signature";
import PhotoTrigger from "components/pages/forms/components/triggerfields/photo/Photo";
import BarcodeTrigger from "components/pages/forms/components/triggerfields/barcode/Barcode";
import VideoTrigger from "components/pages/forms/components/triggerfields/video/Video";
import DocumentTrigger from "components/pages/forms/components/triggerfields/document/Document";
import LocationTrigger from "components/pages/forms/components/triggerfields/location/Location";
import FormulaTrigger from "components/pages/forms/components/triggerfields/formula/Formula";
import FormulaScoreComponent from "components/pages/forms/scoreFields/formula/FormulaScoreComponent";
import { unAccessibleRoutes } from "./permission";

export const layoutsItems = [
  {
    name: "Section",
    type: "Section",
    icon: <SectionIcon />,
    component: SectionField,
  },
  {
    name: "Instruction",
    type: "Instruction",
    icon: <InstructionIcon />,
    component: InstructionsField,
  },
];

export const metaData = {
  "field": Field,
  "SubmittedBy": SubmittedBy,
  "TimeToComplete": TimeToComplete,
  "DistanceFromLocation": DistanceLocation,
  "DateSubmitted": DateSubmitted,
  "Project": Project
}
export const prevMetaDataKeys = {
  "Any Field": "field",
  "Submitted By": "SubmittedBy",
  "Time To Complete": "TimeToComplete",
  "Distance from Location (mi)": "DistanceFromLocation",
  "Date Submitted": "DateSubmitted",
  "Project": "Project"
}


export const triggerData = {
  "Yes/No": YesNo,
  "Multiple Choice": MultipleChoiceTrigger,
  "Rating": Rating,
  "Text": Text,
  "Number": Number,
  "Stopwatch": StopWatchTrigger,
  "Checkbox": CheckboxTrigger,
  "Email": EmailTrigger,
  "Date/Time": DateTimeTrigger,
  "Date": DateTimeTrigger,
  "Signature": SignatureTrigger,
  "Photo": PhotoTrigger,
  "Barcode": BarcodeTrigger,
  "Video": VideoTrigger,
  "Document": DocumentTrigger,
  "Location": LocationTrigger,
  "Formula": FormulaTrigger,
}
export const scoringComponent = {
  "Yes/No": YesNoScoreComponent,
  "Stopwatch": StopWatchScoreComponent,
  "Rating": RatingScoreComponent,
  "Checkbox": CheckBoxScoreComponent,
  "Multiple Choice": MultipleScoreChoice,
  "Number": NumberScoreComponent,
  "Formula": FormulaScoreComponent
};
export const generalQuestionsItems = [
  {
    type: "Yes/No",
    name: "Yes/No",
    icon: <YesNoIcon />,
    component: NewYesNoComponent,
  },
  { type: "Text", name: "Text", icon: <TextIcon />, component: TextComponent },
  {
    type: "Multiple Choice",
    name: "Multiple Choice",
    icon: <MultipleChoiceIcon />,
    component: MultipleChoice,
  },
  {
    type: "Number",
    name: "Number",
    icon: <NumberIcon />,
    component: NumberComponent,
  },
  {
    type: "Checkbox",
    name: "Checkbox",
    icon: <CheckboxIcon />,
    component: CheckBoxComponent,
  },
  {
    type: "Date/Time",
    name: "Date/Time",
    icon: <DateTimeIcon />,
    component: DateTimeComponent,
  },
  {
    type: "Rating",
    name: "Rating",
    icon: <RatingIcon />,
    component: RatingComponent,
  },
  {
    type: "Email",
    name: "Email",
    icon: <EmailIcon />,
    component: EmailComponent,
  },
  {
    type: "Stopwatch",
    name: "Stopwatch",
    icon: <StopwatchIcon />,
    component: StopWatch,
  },
];

export const mediaItems = [
  {
    type: "Photo",
    name: "Photo",
    icon: <Photo />,
    component: PhotoComponent,
  },
  {
    type: "Signature",
    name: "Signature",
    icon: <Signature />,
    component: SignatureComponent,
  },
  {
    type: "Barcode",
    name: "Barcode",
    icon: <Barcode />,
    component: BarcodeComponent,
  },
  {
    type: "Video",
    name: "Video",
    icon: <Video />,
    component: VideoComponent,
  },
  {
    type: "Document",
    name: "Document",
    icon: <Document />,
    component: DocumentComponent,
  },
];

export const advancedItems = [
  {
    type: "Formula",
    name: "Formula",
    icon: <Formula />,
    component: FormulaComponent,
  },
  {
    type: "Location",
    name: "Location",
    icon: <Location />,
    component: LocationComponent,
  },
];

export const previewFormFieldsMapping = {
  Section: PreviewSection,
  Instruction: PreviewInstructions,
  "Yes/No": PreviewYesNo,
  Text: PreviewText,
  "Multiple Choice": PreviewMultipleChoice,
  Number: PreviewNumber,
  Checkbox: PreviewCheckbox,
  "Date/Time": PreviewDateTime,
  Rating: PreviewRating,
  Email: PreviewEmail,
  Stopwatch: PreviewStopwatch,
  Photo: PreviewPhoto,
  Signature: PreviewSignature,
  Barcode: PreviewBarcode,
  Video: PreviewVideo,
  Document: PreviewDocument,
  Formula: PreviewFormula,
  Location: PreviewLocation,
};

// Handle file input change
export const handleFile = async (
  file,
  droppedItems,
  selectedData,
  dispatch,
  setDroppedItems,
  setIsLoading
) => {
  setIsLoading({ loading: true, percent: 0 }); // Start with loading true and 0% progress
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  let formData = new FormData();
  formData.append("file", file);

  try {
    const response = await privatePost(UPLOAD, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setIsLoading((prevState) => ({ ...prevState, percent })); // Update percent
          }
        }
      });
    if (!response?.success) {
      setIsLoading((prevState) => ({ ...prevState, isError: true })); // Set loading to false and percent to 100% when done
    }
    const newDocumentUrls =
      response?.data?.data?.map((fileData) => ({
        name: fileData.originalname,
        path: `${baseURL}/uploads/${fileData.filename}`,
      })) || [];

    // **Map through droppedItems to update either main or dependent field**
    const updatedDroppedItems = droppedItems.map((item) => {
      // If the main field matches, update its media
      if (selectedData.id === item.id) {
        return {
          ...item,
          data: {
            ...item.data,
            media: item.data?.media
              ? [...item.data?.media, ...newDocumentUrls]
              : newDocumentUrls,
          },
        };
      }

      // If selectedData.id matches a dependent field, update only that dependent field
      const updatedDependentFields = item.dependentField.map((depField) => {
        if (selectedData.id === depField.id) {
          return {
            ...depField,
            data: {
              ...depField.data,
              media: depField.data?.media
                ? [...depField.data?.media, ...newDocumentUrls]
                : newDocumentUrls,
            },
          };
        }
        return depField;
      });

      return {
        ...item,
        dependentField: updatedDependentFields,
      };
    });

    dispatch(setDroppedItems(updatedDroppedItems));
  } catch (error) {
    console.error("Error fetching form data:", error);
  } finally {
    setIsLoading({ loading: false, percent: 100 }); // Set loading to false and percent to 100% when done
  }
};

export function formatName(str) {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before uppercase letters
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
}


export const fetchImage = async (filepath, setImageSrc) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  if (filepath) {
    try {
      const token = getToken() || "";
      const response = await fetch(
        `${baseURL}/${filepath.replace("public/", "")}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Assuming `props.token` contains your auth token
          },
        }
      );
      if (response.ok) {
        const blob = await response.blob();
        setImageSrc((preValue) => [...preValue, URL.createObjectURL(blob)]);
      } else {
        console.error("Failed to load image:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching image:", error);
    }
  }
};

export const combineClasses = (...classes) => {
  return classes.join(" ");
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const getUserAccess = () => {
  return JSON.parse(localStorage.getItem("currentUser"))?.access
}

export function getUserData(key) {
  return localStorage.getItem("currentUser") ? JSON.parse(localStorage.getItem("currentUser"))[key] : ""
}


export const dateConverter = (str) => {
  const d = new Date(str);
  let mm = d.getMonth() + 1;
  let dd = d.getDate();

  return [
    (mm > 9 ? "" : "0") + mm,
    (dd > 9 ? "" : "0") + dd,
    d.getFullYear(),
  ].join("/");
};

export function getDayAbbreviation(dateStr) {
  if (!dateStr) return
  const date = new Date(dateStr);
  if (isNaN(date)) return 'Invalid date';

  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return days[date.getDay()];
}




export const processArray = async (arr, baseUrl) => {
  for (let i = 0; i < arr.length; i++) {
    const url = baseUrl ? baseUrl + arr[i] : arr[i];

    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = true;
      link.click();
      await new Promise((res) => {
        setTimeout(() => {
          res();
        }, 1000);
      });
    }
  }
};

export const getCurrentUser = (key) => {
  const data = JSON.parse(localStorage.getItem("currentUser"));
  if (!data) return null;

  switch (key) {
    case "token":
      return data?.token;
    case "permission":
      return data?.permission;
    case "role":
      return data?.role;
    case "roleName":
      return data?.roleName;
    case "userId":
      return data?.userId;
    case "isOnlyUser":
      return data?.isOnlyUser;
    default:
      return data;
  }
};

export const requiredMessage = (name) => {
  return `${name} is required!`;
};

export const convertToPermissionsObj = (allEntity, roleWisePermissions) => {
  return (
    allEntity.length &&
    allEntity.reduce((acc, entity) => {
      if (entity.permission.length) {
        let flag = false;
        acc[entity.entityName] = entity.permission.reduce(
          (acc1, permission) => {
            acc1[permission.actionName] = roleWisePermissions.includes(
              permission.id
            );
            if (roleWisePermissions.includes(permission.id)) {
              flag = true;
            }
            return acc1;
          },
          {}
        );
        acc[entity.entityName].isSelected = flag;
      }
      return acc;
    }, {})
  );
};

export const checkRoutePermission = (permission) => {
  // const loggedInPermissions = JSON.parse(localStorage.getItem("permission")) || [];
  const disableRoutes = !unAccessibleRoutes[getUserAccess()]?.includes(permission)
  // return loggedInPermissions.includes(permission)
  return disableRoutes;
};

export const checkPermission = (permissionName) => {
  const permissions = getCurrentUser("permission");
  return (
    permissions.length &&
    permissions.find(
      (permission) => permission.permissionName === permissionName
    )
  );
};

export const onlyNumbersInput = (e) => {
  ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
};

export const getDefaultDates = () => {
  // const now = new Date("2023/11/14")
  const now = new Date();
  let month = now.getDate() > 15 ? now.getMonth() + 1 : now.getMonth();
  let year = now.getFullYear();
  if (month <= 0) {
    year--;
    month = 12 + month;
  }
  if (month < 10) {
    month = "0" + month;
  }
  // return {
  //     startDate: `${year}-${(month-1 < 10 ? "0" : "") + (month - 1)}-14`,
  //     endDate: `${year}-${(month < 10 ? "0" : "") + month}-15`,
  // }
  return {
    startDate: `${year}-${(month - 3 < 10 ? "0" : "") + (month - 3)}-14`,
    endDate: `${year}-${(month < 10 ? "0" : "") + month}-15`,
  };
};

export function formatDate(dateStr) {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

export function fromatDateInMMMD(inputDate) {
  return dayjs(inputDate, "DD/MM/YYYY").format("MMM D");
}

export function formatPDT(date) {
  return dayjs(date).format("MMM D, YYYY h:mm a [PDT]");
}
// Format - 24/08/2024 | 9:39 AM
export function formatDateTime(dateString) {
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return ""; // or return 'Invalid Date' or any other message you prefer
  }

  // Extract day, month, year
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  // Extract hours, minutes, and AM/PM
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // If hour is 0, set to 12

  const formattedTime = `${hours}:${minutes} ${ampm}`;
  const formattedDate = `${month}/${day}/${year}`;


  return `${formattedDate} | ${formattedTime}`;
}

export function convertToUTCAt1159(dateInput) {
  const date = new Date(dateInput); // handles both string or Date
  return new Date(Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23, 59, 0
  )).toISOString();
}


// export const download = (url) => {
//     var element = document.createElement("a");
//     var file = new Blob(
//       [url],
//       { type: url.endsWith(".pdf") ? "application/pdf" : "image/*" }
//     );
//     element.href = URL.createObjectURL(file);
//     // element.href = URL.createObjectURL(file);
//     element.download = url.split("/").slice(-1)[0];
//     element.click();
// }

export const download = async (originalImage) => {
  const image = await fetch(originalImage);

  // Split image name
  const nameSplit = originalImage.split("/");
  const duplicateName = nameSplit.pop();

  const imageBlog = await image.blob();
  const imageURL = URL.createObjectURL(imageBlog);
  const link = document.createElement("a");
  link.href = imageURL;
  link.download = "" + duplicateName + "";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

//Age Time
export const timeAgo = (updatedAt) => {
  const updatedDate = new Date(updatedAt);

  // Check if the parsed date is valid
  if (isNaN(updatedDate.getTime())) {
    return "Invalid date";
  }

  const currentDate = new Date();

  // Ensure the date difference is not negative
  const diffInMs = Math.max(0, currentDate - updatedDate); // Clamp to 0 if negative
  const diffInSeconds = Math.floor(diffInMs / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);
  const diffInYears = Math.floor(diffInDays / 365);

  if (diffInYears > 0) {
    return `${diffInYears} year${diffInYears > 1 ? "s" : ""} ago`;
  } else if (diffInDays > 0) {
    return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
  } else if (diffInHours > 0) {
    return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
  } else if (diffInMinutes > 0) {
    return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
  } else {
    return `${diffInSeconds} second${diffInSeconds > 1 ? "s" : ""} ago`;
  }
};

export const capitalizeFirstLetter = (str) => {
  if (!str) return "-";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getChangedValues = (values, initialValues) => {
  return Object.entries(values).reduce((acc, [key, value]) => {
    const hasChanged = initialValues[key] !== value;

    if (hasChanged) {
      acc[key] = value;
    }

    return acc;
  }, {});
};

export const makeQueryString = (url = "", queryParams = null) => {
  let queryString = `${url}`;

  if (queryParams) {
    const queryParamsArray = Object.keys(queryParams);
    // add ? if index is 0
    // dont add & on last index
    queryParamsArray.forEach((paramKey, index) => {
      queryString = `${queryString}${index === 0 ? "?" : ""}${paramKey}=${queryParams[paramKey]
        }${index !== queryParamsArray.length - 1 ? "&" : ""}`.trim();
    });
  }

  return queryString;
};

export const reCalculateSectionId = (list) => {
  let currentSectionId = 0;
  const SECTION = "Section";
  const updatedItems = list.map((item) => {
    let sectionId = item?.sectionId;
    currentSectionId =
      currentSectionId !== sectionId && item.type === SECTION
        ? sectionId
        : currentSectionId;

    return { ...item, sectionId: currentSectionId };
  });

  return updatedItems;
};

export function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function truncateText(text = "", length = 0) {
  return text.length > length ? text.slice(0, length) + "..." : text;
}

/// nested child drop
export const traverseTree = (currentTree, newItem, targetId) => {
  const list = []
  let parentDropObject = currentTree?.find((e) => e?.id == targetId)
  currentTree.forEach(({ dependentField = [], ...node }) => {
    if (node?._id == targetId || node?.id == targetId) {
      const uniqueId = Date.now() + randomIntFromInterval(1000, 9999);
      const lastItem = dependentField[dependentField?.length - 1];
      newItem.childSectionId = parentDropObject?.sectionId
      newItem.sectionId =
        newItem.type === "Section"
          ? uniqueId // if current element is section then create new id
          : lastItem?.sectionId
            ? lastItem.sectionId // if last element contain sectionId then take that one
            : 0; // else 0

      list.push({ ...node, dependentField: [...dependentField, newItem] })
    } else {
      if (dependentField.length) {
        const uniqueId = Date.now() + randomIntFromInterval(1000, 9999);
        const lastItem = dependentField[dependentField?.length - 1];

        newItem.sectionId =
          newItem.type === "Section"
            ? uniqueId
            : lastItem?.sectionId
              ? lastItem.sectionId
              : 0;

        list.push({ ...node, dependentField: traverseTree(dependentField, newItem, targetId) })
      }
      else {
        list.push({ ...node, dependentField })
      }
    }
  })

  return list
}
export const updateTree = (currentTree = [], updateItem = {}, targetId) => {
  if (!Array.isArray(currentTree) || !targetId) return currentTree;

  return currentTree.map((node) => {
    if (!node) return node; // Safeguard for undefined/null nodes

    const { dependentField = [], ...rest } = node;

    if (node._id === targetId || node.id === targetId) {
      // If the node matches the targetId, update it
      return {
        ...rest,
        dependentField, // Preserve the dependentField
        data: {
          ...node.data, // Preserve existing data
          ...updateItem, // Apply updates
        },
        instructions: updateItem?.instructions,
        allowMultipleAnswers: updateItem?.allowMultipleAnswers,
        includeTimeWithDate: updateItem?.includeTimeWithDate
      };
    }

    if (Array.isArray(dependentField) && dependentField.length > 0) {
      // Recursively update dependentField
      return {
        ...rest,
        dependentField: updateTree(dependentField, updateItem, targetId),
      };
    }

    // Return the node as-is if it doesn't match
    return node;
  });
};



// export const checkboxTree = ()=>{

//   const checkboxItems = checkboxFromTree()

// }


export let evaluationFind = (condition, arr) => {
  let indexes = arr
    ?.map((item, index) => (item === condition ? index : -1))
    .filter(index => index !== -1);


  let results = indexes.map(index => {
    switch (index) {
      case 0:
        return "yes";
      case 1:
        return "no";
      case 2:
        return "n/a";
      default:
        return null;
    }
  });
  return results.filter(Boolean).join(",");
};
export let evaluationFindBound = (condition, item) => {
  let arr = Object.keys(item?.data || {})
    .filter(key => key.startsWith("evaluation"))
    .map(key => item.data[key]);

  const indexes = arr
    ?.map((value, index) => (value === condition ? index : -1))
    .filter(index => index !== -1); // Keep only matching indexes

  const results = indexes.map(index => {
    switch (index) {
      case 0:
        return "lowerBound"; // First evaluation
      case arr.length - 1:
        return "upperBound"; // Last evaluation
      default:
        return "betweenRange"; // Evaluations in between
    }
  });

  return results.join(","); // Join results as a comma-separated string
};


export let traverseTreePayload = (itemsData) => {
  let traverse = itemsData?.filter((item) => item?.type !== "Section" || !item.children || item.children.length === 0)
    .map((item) => {
      const final = {};
      final.type = item.type;
      if (item?.data?.whenEvaluationEquals) {
        final.whenEvaluationEquals = item?.data?.whenEvaluationEquals?.toLowerCase()
        final.on = "evaluation"
      }
      if (item?.data?.whenAnswerEquals) {
        final.whenAnswerEquals = item?.data?.whenAnswerEquals?.toLowerCase()
        final.on = "value"
      }
      if (item?.data?.whenAnswerOutsideRange && item?.type !== "Stopwatch") {
        final.whenAnswerOutsideRange = item?.data?.whenAnswerOutsideRange?.toLowerCase()
        final.on = "range"
      }

      if (item?.type !== "Stopwatch") {
        if (item?.data?.evaluation1 || item?.data?.evaluation2 || item?.data?.evaluation3) {
          let arr = [
            item?.data?.evaluation1,
            item?.data?.evaluation2,
            item?.data?.evaluation3
          ]
          final.evaluation = {
            passOn: evaluationFind("Pass", arr),
            failOn: evaluationFind("Fail", arr),
            neutralOn: evaluationFind("Neutral", arr)
          }
        } else {
          final.evaluation = {
            ...item?.data?.evaluation
          }
        }
      }

      if (item?.type == "Date/Time") {
        final.includeTimeWithDate = item?.data?.includeTimeWithDate || false
      }
      if (item?.type == "Stopwatch") {
        final.evaluation = !Object?.keys(item?.data?.evaluation || {})?.length ? { ...item?.data?.evaluation } : {
          passOn: evaluationFindBound("Pass", item),
          failOn: evaluationFindBound("Fail", item),
          neutralOn: evaluationFindBound("Neutral", item)
        }
        final.typeOfStopwatch = item.data?.typeOfStopwatch || "stopwatch"
        final.whenAnswerOutsideRange = item?.data?.whenAnswerOutsideRange
        final.on = "range"


      }
      if (item?._id) final._id = item._id;
      if (item?.formulaType) final.formulaType = item?.formulaType;
      if (item?.maxFormulaScore) final.maxFormulaScore = item?.maxFormulaScore
      if (item?.formulaType == "Advance") {
        final.advanceFormulaEval = item?.advanceFormulaEval
      }
      final.label = item?.data?.value || item?.name;

      final.dependentField = traverseTreePayload(item?.dependentField) || [];
      ///
      final.options = item?.data?.options || [];
      final.instructions = item?.data?.instructions || item?.instructions || "";
      final.allowMultipleAnswers = item?.allowMultipleAnswers;
      final.media = item?.data?.media
        ? [...item?.data?.media?.map((e) => e?.path)]
        : [];
      final.required = item?.data?.required || false;
      final.weights = item?.weights || [];
      return final;
    });
  return traverse
}

const SECTION = "Section"
export let traverseTreePayloadSection = (itemsData) => {

  let traverse;
  let children;
  itemsData?.forEach((e) => {
    if (e?.type !== SECTION) {
      if (!e?.sectionId) {
        if (e?.childSectionId) {
          traverse = traverseTreePayload(itemsData)
        }
        else {
          traverse = []
        }
      }
      else {
        traverse = traverseTreePayload(itemsData)

      }
    }
    else {
      traverse = itemsData?.filter((item) =>
        item?.type == SECTION && item.children && item.children.length > 0)
        .map((section) => {
          return {
            name: section.data?.value || section?.name || SECTION,
            type: section?.type || SECTION,
            ...(section._id ? { _id: section._id } : {}),
            fields:
              section?.children?.map((child) => {
                if (child?.dependentField?.length) {
                  children = getModifiedItems(child?.dependentField)
                }
                return {
                  type: child.type,
                  ...(child._id ? { _id: child._id } : {}),
                  ...(
                    child?.data?.whenAnswerEquals ? {
                      whenAnswerEquals: child?.data?.whenAnswerEquals?.toLowerCase(),
                      on: "value"
                    } : {}
                  ),
                  ...(
                    child?.data?.whenEvaluationEquals ? {
                      whenEvaluationEquals: child?.data?.whenEvaluationEquals?.toLowerCase(),
                      on: "evaluation"
                    } : {}
                  ),
                  ...(
                    child?.data?.whenAnswerOutsideRange ? {
                      whenAnswerOutsideRange: child?.data?.whenAnswerOutsideRange?.toLowerCase(),
                      on: "range"
                    } : {}
                  ),
                  ...(
                    child?.dependentField?.length ? {
                      dependentField: traverseTreePayloadSection([...child?.dependentField]) || []
                    } : {}
                  ),
                  ...(
                    child?.type === "Date/Time" ?
                      { includeTimeWithDate: child?.data?.includeTimeWithDate || false } : {}
                  ),
                  ...(
                    child?.type !== "Stopwatch" ?
                      child?.data?.evaluation1 || child?.data?.evaluation2 || child?.data?.evaluation3 ?
                        {
                          evaluation: {
                            passOn: evaluationFind("Pass", [child?.data?.evaluation1, child?.data?.evaluation2, child?.data?.evaluation3]),
                            failOn: evaluationFind("Fail", [child?.data?.evaluation1, child?.data?.evaluation2, child?.data?.evaluation3]),
                            neutralOn: evaluationFind("Neutral", [child?.data?.evaluation1, child?.data?.evaluation2, child?.data?.evaluation3])
                          }
                        }

                        :
                        {
                          evaluation: {
                            ...child?.data?.evaluation
                          }
                        }
                      :
                      {
                        evaluation: {
                          passOn: evaluationFindBound("Pass", child),
                          failOn: evaluationFindBound("Fail", child),
                          neutralOn: evaluationFindBound("Neutral", child)
                        },
                        typeOfStopwatch: child?.data?.typeOfStopwatch || "stopwatch"
                      }

                  ),
                  ...(child.formulaType
                    ? { formulaType: child.formulaType }
                    : {}),
                  ...(child.maxFormulaScore
                    ? { maxFormulaScore: child.maxFormulaScore }
                    : {}),
                  label: child?.data?.value || child?.name,
                  options: child?.data?.options || [],
                  instructions: child?.data?.instructions || "",
                  ...(child?.formulaType == "Advance" ? { advanceFormulaEval: child?.advanceFormulaEval || "*1" } : {}),
                  media: child?.data?.media
                    ? [...child?.data?.media?.map((e) => e?.path)]
                    : [],
                  required: child?.data?.required || false,
                  weights: child?.weights || [],

                };
              }) || [],
          };
        }
        );
    }
  })
  return traverse;
}


export const getModifiedItems = (list) => {
  const items = list?.reduce((acc, curr) => {
    if (curr?.type !== "Section" && curr?.sectionId) {
      acc[curr?.sectionId]?.[0]?.children?.push(curr);
    } else {
      acc[curr?.sectionId] = acc[curr?.sectionId]
        ? [...acc[curr?.sectionId], curr]
        : [{ ...curr, ...(curr?.type === "Section" ? { children: [] } : {}) }];
    }

    return acc;
  }, {});

  let updatedItems = [];
  Object.keys(items).forEach((key) => {
    updatedItems = [...updatedItems, ...items[key]];
  });

  return updatedItems;
};


export const findSelectedData = (tree, targetId) => {
  let found = null; // Variable to store the matching object

  const searchTree = (nodes) => {
    if (!nodes || found) return; // Exit if nodes are null or we've already found a match

    for (const node of nodes) {
      if (node.id === targetId) {
        found = node; // Match found, store it and stop further recursion
        return;
      }
      // Recursively search in dependentField
      if (node.dependentField?.length) {
        searchTree(node.dependentField);
      }
    }
  };

  searchTree(tree); // Start searching in the top-level tree
  return found;
};

export const evaluateAnswer = (obj, value) => {
  const entries = Object?.entries(obj || {});

  for (const [key, val] of entries) {
    const values = val?.split(",") || [];
    if (values.includes(value)) {
      switch (key) {
        case "passOn":
          return "Pass";
        case "failOn":
          return "Fail";
        case "neutralOn":
          return "Neutral";
        default:
          return "Pass";
      }
    }
  }

  return "Pass";
};


export const showOptionsDependency = (evaluation, val) => {
  switch (val) {
    case "pass":

      return evaluation?.passOn
    case "fail":

      return evaluation?.failOn
    case "neutral":

      return evaluation?.neutralOn
    case "pass or fail":

      return `${evaluation?.passOn},${evaluation?.failOn}`
    default:
      return evaluation?.passOn
  }
}



///// report dynamic filters

export const extractOptionsBasedOnTypes = (index, operatorOptions = [], formik) => {
  let fieldId = formik?.values?.filters[index]?.fieldId
  let extractType = operatorOptions?.find((e) => e?.id == fieldId)
  switch (extractType?.type) {
    case "Location":
      return [
        {
          label: "Is",
          value: "is"
        },
        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
    case "Stopwatch":
      return [
        {
          label: "Is",
          value: "is"
        },
        {
          label: "Is Not",
          value: "is not"
        },
        {
          label: "Greater Than",
          value: "greater than"
        },
        {
          label: "Greater Than or Equal",
          value: "greater than or equal"
        },
        {
          label: "Less Than",
          value: "less than"
        },
        {
          label: "Less Than or Equal",
          value: "less than or equal"
        },
        {
          label: "Is Between",
          value: "is between"
        },
        {
          label: "Is Not Between",
          value: "is not between"
        },
        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
    case "Project":
      return [
        {
          label: "Is",
          value: "is"
        },
        {
          label: "Is Not",
          value: "is not"
        }
      ]
    case 'Date Submitted':
      return [
        {
          label: "Today",
          value: "today"
        },
        {
          label: "Yesterday",
          value: "yesterday"
        },
        {
          label: "This week (Mon-today)",
          value: "this week"
        },
        {
          label: "Last Week",
          value: "last week"
        },
        {
          label: "Last Month",
          value: "last month"
        },
        {
          label: "This Month (1st-today)",
          value: "this month (1st-today)"
        },
        {
          label: "Previous",
          value: "previous"
        },
        {
          label: "Is After Date",
          value: "is after date"
        },
        {
          label: "Is Before Date",
          value: "is before date"
        },
        {
          label: "Between",
          value: "between"
        }]
    case 'Distance from Location (mi)':
      return [
        {
          label: "Greater Than or Equal",
          value: "greater than or equal"
        },
        {
          label: "Less Than or Equal",
          value: "less than or equal"
        },
        {
          label: "Is Between",
          value: "is between"
        },
        {
          label: "Is not Between",
          value: "is not between"
        }
      ]
    case 'Time to Complete':
      return [
        {
          label: "Greater Than or Equal",
          value: "greater than or equal"
        },
        {
          label: "Less Than or Equal",
          value: "less than or equal"
        },
        {
          label: "Is Between",
          value: "is between"
        },
        {
          label: "Is not Between",
          value: "is not between"
        }
      ]
    case 'submittedBy_meta':
      return [
        {
          label: "Is",
          value: "is"
        },
        {
          label: "Contains",
          value: "contains"
        }
      ]
    case 'Any Field':
      return [
        {
          label: "Contains",
          value: "contains",
          disabled: true
        }
      ]
    case "Yes/No":
      return [

        {
          label: "Is Yes",
          value: "is yes"
        },
        {
          label: "Is No",
          value: "is no"
        },
        {
          label: "Is N/A",
          value: "is n/a"
        },
        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]


    case "Photo":
      return [

        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
    case "Email":
      return [
        {
          label: "Is",
          value: "is"
        },
        {
          label: "Contains",
          value: "contains"
        },
        {
          label: "Does Not Contain",
          value: "does not contain"
        },
        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
    case "Checkbox":
      return [
        // {
        //   type: "value"
        // },
        {
          label: "Checked",
          value: "checked"
        },
        {
          label: "Not Checked",
          value: "unchecked"
        }
      ]
    case "Date/Time":
      return [
        // {
        //   type: "value"
        // },
        {
          label: "Today",
          value: "today"
        },
        {
          label: "Yesterday",
          value: "yesterday"
        },
        {
          label: "This week (Mon-today)",
          value: "this week"
        },
        {
          label: "Last Week",
          value: "last week"
        },
        {
          label: "This Month (1st-today)",
          value: "this month (1st-today)"
        },
        {
          label: "Last Month",
          value: "last month"
        },
        {
          label: "Previous",
          value: "previous"
        },
        {
          label: "Is After Date",
          value: "is after date"
        },
        {
          label: "Is Before Date",
          value: "is before date"
        },
        {
          label: "Between",
          value: "is between"
        },
        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
    case "Rating":
      return [
        {
          label: "Is",
          value: "is"
        },
        {
          label: "Is Not",
          value: "is not"
        },
        {
          label: "Greater Than",
          value: "greater than"
        },
        {
          label: "Greater Than or Equal",
          value: "greater than or equal"
        },
        {
          label: "Less Than",
          value: "less than"
        },
        {
          label: "Less Than or Equal",
          value: "less than or equal"
        },
        {
          label: "Is Between",
          value: "is between"
        },
        {
          label: "Is Not Between",
          value: "is not between"
        },
        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
    case "Multiple Choice":
      return [
        {
          label: "Is",
          value: "is"
        },
        {
          label: "Contains",
          value: "contains"
        },
        {
          label: "Does Not Contain",
          value: "does not contain"
        },
        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
    case "Number":
      return [
        {
          label: "Is",
          value: "is"
        },
        {
          label: "Is Not",
          value: "is not"
        },
        {
          label: "Greater Than",
          value: "greater than"
        },
        {
          label: "Greater Than or Equal",
          value: "greater than or equal"
        },
        {
          label: "Less Than",
          value: "less than"
        },
        {
          label: "Less Than or Equal",
          value: "less than or equal"
        },
        {
          label: "Is Between",
          value: "is between"
        },
        {
          label: "Is Not Between",
          value: "is not between"
        },
        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
    case "Text":
      return [
        {
          label: "Is",
          value: "is"
        },
        {
          label: "Contains",
          value: "contains"
        },
        {
          label: "Does Not Contain",
          value: "does not contain"
        },
        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
    case "Barcode":
      return [
        {
          label: "Is",
          value: "is"
        },
        {
          label: "Contains",
          value: "contains"
        },
        {
          label: "Does Not Contain",
          value: "does not contain"
        },
        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
    case "Formula":
      return [
        {
          label: "Is",
          value: "is"
        },
        {
          label: "Is Not",
          value: "is not"
        },
        {
          label: "Greater Than",
          value: "greater than"
        },
        {
          label: "Greater Than or Equal",
          value: "greater than or equal"
        },
        {
          label: "less Than",
          value: "less than"
        },
        {
          label: "less Than or Equal",
          value: "less than or equal"
        },
        {
          label: "Is Between",
          value: "is between"
        },
        {
          label: "Is Not Between",
          value: "is not between"
        },
        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
    default:
      return [

        {
          label: "Is Answered",
          value: "is answered"
        },
        {
          label: "Is Unanswered",
          value: "is unanswered"
        }
      ]
  }

}

export const extractValuesBasedOnOptions = (index, formik, operatorOptions) => {
  let options = formik?.values?.filters[index]?.condition
  let fieldId = formik?.values?.filters[index]?.fieldId

  let extractType = operatorOptions?.find((e) => e?.id == fieldId)
  let valueOptions = [
    {
      label: "Yes", value: "yes"
    },
    {
      label: "No", value: "no"
    },
    {
      label: "Maybe", value: "maybe"
    }
  ]
  switch (options) {
    // case "is between":
    //   return "multi_date"
    case "between":
      return "multi_date"
    case "is after date":
      return "date"
    case "is before date":
      return "date"
    case "contains":
      return {
        type: "text"
      }
    case "previous":
      return {
        type: "previous"
      }
    case "is between":
      if (extractType?.type == 'Time to Complete' || extractType?.type == "Stopwatch") {
        return "multi_mask"

      } else if (extractType?.type == "Date/Time") {
        return "multi_date"
      }
      else {
        return {
          type: "arrayvalue"
        }
      }

    case "is not between":
      if (extractType?.type == 'Time to Complete' || extractType?.type == "Stopwatch") {
        return "multi_mask"

      } else {
        return {
          type: "arrayvalue"
        }
      }
    case "contains":
      return {
        type: "text"
      }
    case "greater than":
      if (extractType?.type == "Stopwatch") {
        return "single_mask"

      } else {
        return {
          type: "text"
        }
      }
    case "greater than or equal":
      if (extractType?.type == 'Time to Complete' || extractType?.type == "Stopwatch") {
        return "single_mask"

      } else {
        return {
          type: "text"
        }
      }

    case "less than":
      if (extractType?.type == "Stopwatch") {
        return "single_mask"

      } else {
        return {
          type: "text"
        }
      }
    case "less than or equal":
      if (extractType?.type == 'Time to Complete' || extractType?.type == "Stopwatch") {
        return "single_mask"

      } else {
        return {
          type: "text"
        }
      }
    case "does not contain":
      if (extractType?.type == "Multiple Choice") {
        return {
          type: "select",
          options: [
            {
              label: "Yes", value: "yes"
            },
            {
              label: "No", value: "no"
            },
            {
              label: "Maybe", value: "maybe"
            },
          ]
        }
      } else {
        return {
          type: "text"
        }
      }
    case "is not":
      if (extractType?.type == "Number" || extractType?.type == "Formula" || extractType?.type == "Project") {
        return {
          type: "text"
        }
      }

    case "is":
      if (extractType?.type == "Text" || extractType?.type == "Number" || extractType?.type == "Email" || extractType?.type == "Barcode" || extractType?.type == "Formula" || extractType?.type == "Rating" || extractType?.type == "Project") {
        return {
          type: "text"
        }
      }
      else if (extractType?.type == "Stopwatch") {
        return "single_mask"
      }
      else if (extractType?.type == "submittedBy_meta") {
        return "user"
      }
      else if (extractType?.type == 'Location') {
        return "location"
      }
      // else if (extractType?.type == 'Submitted By') {
      //   return "teams"
      // }

      else if (extractType?.type == "Multiple Choice") {
        return {
          type: "dynamic_select",
        }
      }
      else if (extractType?.type == "Multiple Choice") {
        return {
          type: "dynamic_select",
        }
      }
      else {
        return {
          type: "select",
          options: valueOptions
        }
      }

    default:
      return false
  }

}



export const handleMultiFileUpload = async (files, setLoading) => {
  setLoading({ loading: true, percent: 0 }); // Start with loading true and 0% progress
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("file", file); // Append each file to the FormData object
  });

  try {
    const response = await privatePost(UPLOAD, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setLoading((prevState) => ({ ...prevState, percent })); // Update percent
          }
        }
      });
    if (!response?.data?.success) {

      throw new Error("File upload failed"); // Handle error if response is not successful
    } else {
      const newDocumentUrls =
        response?.data?.data?.map((fileData) => ({
          name: fileData.originalname,
          path: `${baseURL}/uploads/${fileData.filename}`,
        })) || [];
      setLoading({ loading: false, percent: 100 }); // Set loading to false and percent to 100% when done
      return newDocumentUrls;
    }

  } catch (error) {
    setLoading((prevState) => ({ ...prevState, isError: true })); // Set loading to false and percent to 100% when done
    throw new Error(error); // Handle error if response is not successful
  }finally {
    setLoading({ loading: false, percent: 100 }); // Set loading to false and percent to 100% when done
  }
}


export const handleSingleFileUpload = async (file, setLoading) => {
  setLoading({ loading: true, percent: 0 }); // Start with loading true and 0% progress
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const formData = new FormData();
  formData.append("file", file); // Append the single file

  try {
    const response = await privatePost(UPLOAD, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setLoading((prevState) => ({ ...prevState, percent })); // Update percent
        }
      }
    });

    if (!response?.data?.success) {
      throw new Error("File upload failed"); // Handle error if response is not successful
    }

    const fileData = response?.data?.data?.[0];
    const fileUrl = {
      name: fileData.originalname,
      path: `${baseURL}/uploads/${fileData.filename}`,
    };

    return fileUrl;

  } catch (error) {
    setLoading((prevState) => ({ ...prevState, isError: true }));
    throw new Error(error);
  } finally {
    setLoading({ loading: false, percent: 100 });
  }
};

export const imageExtensions = [
  "jpg", "jpeg", "png", "gif", "bmp", "tiff", "tif", "webp", 
  "svg", "ico", "heic", "heif", "jfif", "avif"
];


export const trimFileName = (filePath) => {
  const fullName = filePath.split("/").pop(); // Get file name with extension
  const dotIndex = fullName.lastIndexOf(".");
  if(fullName.length < 15){
    return fullName
  }

  if (dotIndex === -1) return fullName.slice(0, 10) + ".."; // No extension

  const name = fullName.slice(0, dotIndex);
  const ext = fullName.slice(dotIndex);

  return name.slice(0, 10) + ".." + ext;
};